import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppConfig } from '../../components/common/CommonTypes';
import { Journey } from '../../consts/Common';
import { getSuppressionPageDetails } from '../thunks/getSuppressionContent';

/**
 * Redux slice state for app configuration flags and values returned by the backend.
 */
type SliceState = AppConfig;

/**
 * Initial app configuration state.
 */
const initialSiteState: SliceState = {
  sagePayBaseUrl: '',
  journeyType: Journey.Initial,
  recordId: '',
  renewalSourceSystem: '',
  includeQuotes: false,
  includeOpenSite: false,
  isAppUnderMaintenance: false,
  maintenanceMessage: '',
  countryCode: '',
  cultureCode: 'en-gb',
  quoteUpsell: false,
  maxLoginAttempts: 0
};

/**
 * Config slice containing reducers for storing app config values.
 */
const config = createSlice({
  name: 'appConfig',
  initialState: initialSiteState,
  reducers: {
    /** Replaces the entire app config state with the provided payload. */
    setAppConfig: (_, action: PayloadAction<SliceState>) => action.payload
  },
  extraReducers: (builder) => {
    builder.addCase(getSuppressionPageDetails.fulfilled, (s, action) => {
      s.countryCode = action.payload.countryCode ?? '';
      s.journeyType = Journey.General;
      s.isAppUnderMaintenance = action.payload.isAppUnderMaintenance ?? false;
      s.maintenanceMessage = action.payload.maintenanceMessage ?? '';
      s.cultureCode =
        action.payload.cultureCode ?? initialSiteState.cultureCode;
    });
  }
});

export const { setAppConfig } = config.actions;

export default config.reducer;
